import React from 'react';
import { Route } from 'react-router-dom';
import { eAccessControlUserType } from 'ui-toolkit/enums/eAccessControlUserType';
import { TitleReportRouter } from './TitleReportRouter';
import { TaxCertificationContainer } from 'pages/order/taxCertifications/TaxCertificationContainer';
import { VendorTaxCertificationsContainer } from '../pages/vendorDashboard/VendorTaxCertificationsContainer';
import { VendorTaxCertificationContainer } from '../pages/vendorDashboard/VendorTaxCertificationContainer';
import { VendorOrdersContainer } from '../pages/vendorDashboard/orders/VendorOrdersContainer';
import { VendorPayoffsContainer } from '../pages/vendorDashboard/payoffs/VendorPayoffsContainer';
import { VendorPayoffContainer } from '../pages/vendorDashboard/payoffs/VendorPayoffContainer';
import { VendorOrderContainer } from '../pages/vendorDashboard/orders/VendorOrderContainer';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { useLoginRedirect } from 'store/authentication/useLoginRedirect';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { AccessControlCheck } from 'components/accessControl/AccessControlCheck';

export const VendorRoutes: React.FC = () => {
  const { path } = useRouteMatch();
  const goLoginRedirect = useLoginRedirect();
  return (
    <AccessControlCheck
      allowedPermissions={[ePermissions.ReadVendorPortal]}
      actionOnFailure={() => goLoginRedirect(eAccessControlUserType.Vendor)}
    >
      <Switch>
        <Route path={`${path}`} exact render={({ location: { pathname } }) => <Redirect to={`${pathname}/orders`} />} />
        <Route path={`${path}/order/:orderId`} exact component={VendorOrderContainer} />
        <Route path={`${path}/order/:orderId/report`} component={TitleReportRouter} />
        <Route path={`${path}/order/:orderId/taxCertification`} component={TaxCertificationContainer} />
        <Route path={`${path}/orders`} component={VendorOrdersContainer} />

        <Route path={`${path}/payoff/:orderId`} exact component={VendorPayoffContainer} />
        <Route path={`${path}/payoffs`} exact component={VendorPayoffsContainer} />

        <Route path={`${path}/tax_certification/:orderId`} exact component={VendorTaxCertificationContainer} />
        <Route path={`${path}/tax_certifications`} exact component={VendorTaxCertificationsContainer} />
        <Route path={`${path}/*`} render={() => <Redirect to={`${path}/orders`} />} />
      </Switch>
    </AccessControlCheck>
  );
};
